import { Button, Tooltip } from "@digdir/designsystemet-react";
import { InformationIcon } from "@navikt/aksel-icons";
import type { FC } from "react";
import "./InfoTooltip.css";

interface InfoTooltipProps {
    placement?: "top" | "right" | "bottom" | "left";
    text: string;
    withBg?: boolean;
}

export const InfoTooltip: FC<InfoTooltipProps> = ({ text, withBg = false, placement = "right" }) => {
    return (
        <Tooltip content={text} placement={placement}>
            <Button
                className={`info-tooltip ${withBg ? "info-tooltip--with-bg" : ""}`}
                icon
                aria-label={text}
                data-color="neutral"
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
            >
                <InformationIcon aria-hidden />
            </Button>
        </Tooltip>
    );
};
